'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkflowSwitch = function WorkflowSwitch(props) {
    var intl = props.intl;


    (0, _react.useEffect)(function () {
        if (props.return && props.return.elements && !(0, _metrixCommon.getElementValueByCode)(props.return.elements, 'Value')) {
            props.doSetReturn({ componentCode: props.component.code, code: 'Value', value: 'false' });
        }
    }, [props]);

    var getOverrideValue = function getOverrideValue(overrideCode, defaultValue) {
        var overrideKey = (0, _metrixCommon.getElementValueByCode)(props.component.elements, overrideCode);
        if (overrideKey && props.workflowConfiguration) {
            var normalizedKey = overrideKey.charAt(0).toLowerCase() + overrideKey.slice(1);
            var overrideValue = props.workflowConfiguration[normalizedKey];
            if (overrideValue) {
                return overrideValue;
            }
        }
        return defaultValue;
    };

    var processPlaceholders = function processPlaceholders(text, targets) {
        var placeholderPattern = /@&[^&]+&@/g;
        var placeholders = text.match(placeholderPattern) || [];
        var targetArray = targets.split(',');

        if (placeholders.length > targetArray.length) {
            // Remove extra placeholders
            var count = 0;
            text = text.replace(placeholderPattern, function (match) {
                count++;
                return count <= targetArray.length ? match : match.slice(2, -2);
            });
        } else if (placeholders.length < targetArray.length) {
            // Remove extra targets
            targetArray.length = placeholders.length;
        }

        return { text: text, targets: targetArray.join(',') };
    };

    var getLocalizedText = function getLocalizedText(textKey) {
        try {
            var parsedText = JSON.parse(textKey);

            // Check if it's a message ID for react-intl
            if (parsedText.messageId) {
                return intl.formatMessage({
                    id: parsedText.messageId,
                    defaultMessage: parsedText.defaultText || textKey
                });
            }

            // For backward compatibility, still handle the old format
            if (parsedText.localization) {
                var locale = intl.locale || 'en';
                return parsedText.localization[locale] || textKey;
            }

            return textKey;
        } catch (e) {
            // If it's not JSON or doesn't have expected format,
            // check if it's a direct message ID
            if (typeof textKey === 'string' && textKey.includes('.')) {
                return intl.formatMessage({
                    id: textKey,
                    defaultMessage: textKey
                });
            }
            return textKey;
        }
    };

    var unlocalizedText = getOverrideValue('WorkflowConfigurationOverrideText', (0, _metrixCommon.getElementValueByCode)(props.component.elements, 'Text'));
    var targets = getOverrideValue('WorkflowConfigurationOverrideTargets', (0, _metrixCommon.getElementValueByCode)(props.component.elements, 'Targets') || '');
    var textLeft = (0, _metrixCommon.getElementValueByCode)(props.component.elements, 'LeftText');
    var targetsLeft = (0, _metrixCommon.getElementValueByCode)(props.component.elements, 'LeftTargets');
    var value = props.return && (0, _metrixCommon.getElementValueByCode)(props.return.elements, 'Value') && (0, _metrixCommon.getElementValueByCode)(props.return.elements, 'Value') === 'true';

    var _processPlaceholders = processPlaceholders(getLocalizedText(unlocalizedText), targets),
        processedText = _processPlaceholders.text,
        processedTargets = _processPlaceholders.targets;

    return _react2.default.createElement(_metrixCommon.Switch, _extends({
        componentCode: 'WorkflowSwitch',
        text: processedText,
        textLeft: textLeft ? getLocalizedText(textLeft) : textLeft,
        textAlign: _metrixCommon.Alignments.right,
        value: value,
        targets: processedTargets,
        targetsLeft: targetsLeft,
        clickEvent: function clickEvent(value) {
            return props.doSetReturn({
                componentCode: props.component.code,
                code: 'Value',
                value: value.toString()
            });
        }
    }, props));
};

exports.default = (0, _reactIntl.injectIntl)(WorkflowSwitch);